import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Bridge from "./pages/Bridge";
import Academy from "./pages/Academy";
import Mentors from "./pages/Mentors";
import Sentinel from "./pages/Sentinel";
import CadetPicker from "./components/CadetPicker";
import { getActiveCadetId } from "./lib/api";

function App() {
  const [authed, setAuthed] = useState(!!getActiveCadetId());

  useEffect(() => {
    const onSwitch = () => setAuthed(false);
    window.addEventListener("cyberkids:switch-cadet", onSwitch);
    return () => window.removeEventListener("cyberkids:switch-cadet", onSwitch);
  }, []);

  if (!authed) {
    return (
      <div className="App">
        <CadetPicker onSelected={() => setAuthed(true)} />
        <Toaster theme="dark" position="top-right" />
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Bridge />} />
          <Route path="/academy" element={<Academy />} />
          <Route path="/mentors" element={<Mentors />} />
          <Route path="/sentinel" element={<Sentinel />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default App;
